export default "__VITE_ASSET__DKbKhraB__"